<script setup lang="ts">
defineOptions({
  name: 'LinkAuth',
})

withDefaults(defineProps<LinkAuthProps>(), {
  target: '_self',
})

interface LinkAuthProps {
  text: string
  href: string
  target?: '_self' | '_blank'
}

</script>

<template>
  <a
    class="link-auth"
    :target="target"
    :href="href"
  >
    {{ text }}
  </a>
</template>

<style scoped lang="scss" src="./LinkAuth.scss" />
